export default [
    {
        dropNumber: '#000',
        title: 'OGs',
        sections: [
            {
                type: 'image',
                name: '"OGs"',
                image_link: 'https://magiceden.us/ordinals/marketplace/ume-ogs',
                description: '33 ordinals airdropped to UME OGs!<br><br>First is First.',
                image_url: 'https://storage.googleapis.com/virulent-software-python-1.appspot.com/_UME/_images/all_33_og.png'
            }
        ]
    },
    {
        dropNumber: '#001',
        title: 'Bad Santa',
        sections: [
            {
                type: 'video',
                name: '"Bad Santa"',
                description: '100/100 inflatable wearables for Bitcoin Puppets holders.<br><br>Merry Xmas Mfers 🎁',
                video_url: 'https://storage.googleapis.com/virulent-software-python-1.appspot.com/_UME/_video/puppet_costume_hero_final_02.mp4'
            }
        ]
    },
    {
        dropNumber: '#002',
        title: 'Free Ross',
        sections: [
            {
                type: 'video',
                name: '"Free Ross"',
                description: '100/100 hoodies for OMB holders.<br><br>Followers chase culture. Leaders create it.',
                video_url: 'https://storage.googleapis.com/virulent-software-python-1.appspot.com/_UME/_video/hoodie_final_v5.mp4'
            }
        ]
    },
    {
        dropNumber: '#003',
        title: 'Headcases',
        sections: [
            {
                type: 'video-cta',
                name: '"Headcases"',
                description: '100/100 custom ordinals on Bitcoin.<br><br>What will you create mfer? 🧊',
                video_url: 'https://storage.googleapis.com/virulent-software-python-1.appspot.com/_UME/_video/hc_hero_final_02.mp4',
                cta: 
                {
                    name: 'CREATE',
                    url: '/headcases',
                    id: 'headcases-create-button'
                }
            }            
        ]
    },
    {
        dropNumber: '#004',
        title: 'Dog Tags',
        sections: [
            {
                type: 'video',
                name: '"Dog Tags To The Moon"',
                description: '1M $DOG prizepool drip fed daily for holders.<br><br>Woof Woof.',
                video_url: 'https://storage.googleapis.com/virulent-software-python-1.appspot.com/_UME/_video/dog_moon_v5.mp4'
            }
        ]
    },
    {
        dropNumber: '#005',
        title: 'Snuggie of Ord',
        sections: [
            {
                type: 'video',
                name: '"The Snuggie of Ord"',
                description: 'An enchanted robe that delivers warmth and a measurable stat bonus.<br><br>+1 Charisma.',
                video_url: 'https://storage.googleapis.com/virulent-software-python-1.appspot.com/_UME/_video/final_snug_sqnce.2.mp4'
            }
        ]
    }
]